<template>
  <div>
    <p
      v-if="usage.plan.id === 'pay-as-you-go'"
      class="w-full text-center mb-sm text-primaryGradient font-bold text-18 cursor-default"
      :class="{'!text-danger': paygCreditWarning}"
    >
      {{ $t('ui.envelopes.envelopesPage.usageWidget.envelopeUsageWidgetMetricDisplay.xCreditsRemaining', { x: usage.credits }) }}
    </p>
    <div v-else>
      <p
        class="w-full text-center mb-sm text-primaryGradient font-bold text-14 select-none"
        :class="{'!text-danger': planUsageWarning}"
      >
        {{ $t('ui.envelopes.envelopesPage.usageWidget.envelopeUsageWidgetMetricDisplay.xEnvelopesRemaining', { x: envelopesRemaining }) }}
      </p>
      <div class="bg-widgetHeader p-xs -mx-xs rounded-full">
        <div class="bg-hoverGray rounded-full overflow-hidden">
          <div
            class="h-eighteen bg-primaryGradient"
            :class="{'!bg-danger': planUsageWarning}"
            :style="{ width: envelopesRemainingAsPercentage }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnvelopeUsageWidgetMetricDisplay',
  props: {
    usage: {
      type: Object,
      required: true,
    },
  },
  computed: {
    envelopesRemaining() {
      return this.usage.plan.allowance - this.usage.usage;
    },
    envelopesRemainingAsPercentage() {
      return `${ (this.envelopesRemaining / this.usage.plan.allowance) * 100 }%`;
    },
    paygCreditWarning() {
      return this.usage.credits < 5;
    },
    planUsageWarning() {
      const remainingPercentage = (this.envelopesRemaining / this.usage.plan.allowance) * 100;
      return this.envelopesRemaining < 5 || remainingPercentage < 5;
    },
  },
};

</script>
